/**
 * Safe localStorage helpers with try/catch wrappers.
 */

export function getStorageItem<T extends string>(key: string, fallback: T): T {
  try {
    return (localStorage.getItem(key) as T) || fallback;
  } catch {
    return fallback;
  }
}

export function setStorageItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Silently fail — quota exceeded or private mode
  }
}
